type TabEvent = Pick<KeyboardEvent, 'key' | 'shiftKey' | 'preventDefault'>

export function trapDialogFocus(
  event: TabEvent,
  root: HTMLElement | null,
  initialFocus?: HTMLElement | null,
) {
  if (event.key !== 'Tab' || !root) return
  const controls = Array.from(
    root.querySelectorAll<HTMLElement>(
      'button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]',
    ),
  ).filter(element => element.getClientRects().length > 0)
  const first = controls[0]
  const last = controls[controls.length - 1]
  if (!first || !last) return
  const atInitialFocus =
    initialFocus && root.contains(initialFocus) && document.activeElement === initialFocus
  const target = atInitialFocus
    ? event.shiftKey
      ? last
      : first
    : !root.contains(document.activeElement)
      ? first
      : event.shiftKey && document.activeElement === first
        ? last
        : !event.shiftKey && document.activeElement === last
          ? first
          : null
  if (target) {
    event.preventDefault()
    target.focus()
  }
}
